import React from 'react';
export function ShoppingCartIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.624 4H1V2h4.375l.4 3H23v3.162L20.72 15H7.11l.266 2H21v1.268A2 2 0 0120 22a2 2 0 01-1.733-3H7.732a2 2 0 11-2.233-.937L3.624 4zm2.818 6l-.4-3H21v.838L20.28 10H6.441z"
  }));
}